import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  message: {
    display: 'grid',
    gridTemplateColumns: 'minmax(20px, auto) auto',
    alignItems: 'center',
    color: '#8F8F8F',
    fontSize: theme.size.sm,
    justifyContent: 'center',
    cursor: 'default',
    margin: '0',
    minHeight: '17px',

    '& > span': {
      color: 'rgba(127,132,135, 0.5)',
      marginRight: '0.25rem'
    },

    [theme.breakpoints.down('md')]: {
      display: 'block !important',
      textAlign: 'center',
      height: 'auto !important'
    }
  },

  line: {
    color: '#8F8F8F !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  mobileLine: {
    color: '#8F8F8F !important'
  },

  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  bold: {
    margin: '0 3px',
    color: '#8F8F8F !important',

    [theme.breakpoints.down('md')]: {
      margin: '0'
    }
  },

  date: {
    margin: '0 3px',

    [theme.breakpoints.down('md')]: {
      margin: '0'
    }
  },

  additionalMargin: {
    margin: '0 8px !important'
  },

  forceFlex: {
    display: 'flex !important',

    [theme.breakpoints.down('md')]: {
      gap: 3
    }
  }
}))

export default useStyles
